namespace Gamification.Gamification {
    export interface ApiComandiForm {
        IdApi: Serenity.LookupEditor;
        IdApiOperazione: Serenity.LookupEditor;
        Comando: Serenity.TextAreaEditor;
        Descrizione: Serenity.TextAreaEditor;
    }

    export class ApiComandiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ApiComandi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiComandiForm.init)  {
                ApiComandiForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(ApiComandiForm, [
                    'IdApi', w0,
                    'IdApiOperazione', w0,
                    'Comando', w1,
                    'Descrizione', w1
                ]);
            }
        }
    }
}
